import React from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  Card,
  Typography,
  Avatar,
  Divider,
} from "antd";
import {
  CarOutlined,
  SwapOutlined,
  DollarCircleOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

/**
 * RtaCard — three stat sections shown as a single card:
 *
 *  1. RTA Records  — total | purchase | sale | ovf | seizing | frc
 *  2. Ownership Transfer — total | firm | staff | customer
 *  3. Hold Amount  — total hold ₹ | released ₹ | pending ₹
 *                    + record counts: with-hold | released | pending
 */
function RtaCard(props) {
  const { rtaRecords, rtaOwnershipTransfer, rtaHoldAmount, rtaStatus } = props;

  const fmt = (val) =>
    val !== undefined && val !== null ? Number(val).toLocaleString("en-IN") : 0;

  return (
    <Row gutter={[12, 12]}>
      {/* ── 1. RTA Records ─────────────────────────────────────── */}
      <Col xs={24} sm={24} md={8}>
        <Card
          className="hp-border-color-black-40 hp-transition hp-hover-border-color-primary-4 hp-card-6"
          bodyStyle={{ padding: "14px 16px" }}
          actions={[
            <span key="pur">
              <Text type="secondary" className="hp-d-block hp-caption">Purchase</Text>
              <Text strong>{fmt(rtaRecords?.purchase)}</Text>
            </span>,
            <span key="sale">
              <Text type="success" className="hp-d-block hp-caption">Sale</Text>
              <Text strong>{fmt(rtaRecords?.sale)}</Text>
            </span>,
            <span key="ovf">
              <Text type="warning" className="hp-d-block hp-caption">OVF</Text>
              <Text strong>{fmt(rtaRecords?.ovf)}</Text>
            </span>,
            <span key="seizing">
              <Text type="secondary" className="hp-d-block hp-caption">Seizing</Text>
              <Text strong>{fmt(rtaRecords?.seizing)}</Text>
            </span>,
            <span key="frc">
              <Text type="secondary" className="hp-d-block hp-caption">FRC</Text>
              <Text strong>{fmt(rtaRecords?.frc)}</Text>
            </span>,
            <span key="finance_sale">
              <Text type="danger" className="hp-d-block hp-caption">Finance Sale</Text>
              <Text strong>{fmt(rtaRecords?.finance_sale)}</Text>
            </span>,
          ]}
        >
          <Row align="middle" gutter={[8, 0]}>
            <Col span={5}>
              <Avatar
                size={45}
                icon={<CarOutlined />}
                className="hp-bg-primary-1 hp-text-color-black-0"
              />
            </Col>
            <Col span={19}>
              <Text className="h6 hp-d-block" strong>
                RTA Records
              </Text>
              <Text className="h4" strong>
                {fmt(rtaRecords?.total)}
              </Text>
            </Col>
          </Row>
        </Card>
      </Col>

      {/* ── 2. Ownership Transfer ───────────────────────────────── */}
      <Col xs={24} sm={24} md={8}>
        <Card
          className="hp-border-color-black-40 hp-transition hp-hover-border-color-primary-4 hp-card-6"
          bodyStyle={{ padding: "14px 16px" }}
          actions={[
            <span key="firm">
              <Text type="secondary" className="hp-d-block hp-caption">
                Firm
              </Text>
              <Text strong>{fmt(rtaOwnershipTransfer?.to_firm)}</Text>
            </span>,
            <span key="staff">
              <Text type="warning" className="hp-d-block hp-caption">
                Staff
              </Text>
              <Text strong>{fmt(rtaOwnershipTransfer?.to_staff)}</Text>
            </span>,
            <span key="customer">
              <Text type="success" className="hp-d-block hp-caption">
                Customer
              </Text>
              <Text strong>{fmt(rtaOwnershipTransfer?.to_customer)}</Text>
            </span>,
          ]}
        >
          <Row align="middle" gutter={[8, 0]}>
            <Col span={5}>
              <Avatar
                size={45}
                icon={<SwapOutlined />}
                style={{ backgroundColor: "#52c41a" }}
                className="hp-text-color-black-0"
              />
            </Col>
            <Col span={19}>
              <Text className="h6 hp-d-block" strong>
                Ownership Transfer
              </Text>
              <Text className="h4" strong>
                {fmt(rtaOwnershipTransfer?.total)}
              </Text>
            </Col>
          </Row>
        </Card>
      </Col>

      {/* ── 3. Hold Amount ──────────────────────────────────────── */}
      <Col xs={24} sm={24} md={8}>
        <Card
          className="hp-border-color-black-40 hp-transition hp-hover-border-color-primary-4 hp-card-6"
          bodyStyle={{ padding: "14px 16px" }}
          actions={[
            <span key="rel">
              <Text type="success" className="hp-d-block hp-caption">
                Released ₹
              </Text>
              <Text strong>{fmt(rtaHoldAmount?.total_released_amount)}</Text>
            </span>,
            <span key="pend">
              <Text type="danger" className="hp-d-block hp-caption">
                Pending ₹
              </Text>
              <Text strong>{fmt(rtaHoldAmount?.total_pending_amount)}</Text>
            </span>,
          ]}
        >
          <Row align="middle" gutter={[8, 0]}>
            <Col span={5}>
              <Avatar
                size={45}
                icon={<DollarCircleOutlined />}
                style={{ backgroundColor: "#faad14" }}
                className="hp-text-color-black-0"
              />
            </Col>
            <Col span={19}>
              <Text className="h6 hp-d-block" strong>
                Hold Amount
              </Text>
              <Text className="h4" strong>
                ₹ {fmt(rtaHoldAmount?.total_hold_amount)}
              </Text>
            </Col>
          </Row>
          {/* <Divider className="hp-mb-8 hp-mt-8" />
          <Row gutter={[8, 0]}>
            <Col span={8}>
              <Text type="secondary" className="hp-caption">
                With Hold
              </Text>
              <Text strong className="hp-d-block">
                {fmt(rtaHoldAmount?.rta_with_hold)}
              </Text>
            </Col>
            <Col span={8}>
              <Text type="success" className="hp-caption">
                Released
              </Text>
              <Text strong className="hp-d-block">
                {fmt(rtaHoldAmount?.rta_hold_released)}
              </Text>
            </Col>
            <Col span={8}>
              <Text type="danger" className="hp-caption">
                Pending
              </Text>
              <Text strong className="hp-d-block">
                {fmt(rtaHoldAmount?.rta_hold_pending)}
              </Text>
            </Col>
          </Row> */}
        </Card>
      </Col>
    </Row>
  );
}

function mapStateToProps({ dashboard }) {
  return {
    rtaRecords: dashboard.rtaRecords,
    rtaOwnershipTransfer: dashboard.rtaOwnershipTransfer,
    rtaHoldAmount: dashboard.rtaHoldAmount,
    rtaStatus: dashboard.rtaStatus,
  };
}

export default connect(mapStateToProps, {})(RtaCard);
